//* 组件库
import { $message, $loading } from "various-ui";
//* xlsl解析库
import * as XLSX from "xlsx";
//* 私有组件
import type ModuleForm from "../components/module-form/index.vue";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        name: ref<string>(""),
        data: ref<{ mm_entrez: number; effect_size: number }[]>([]),
        mode: ref<string>(""),
        accept: ".csv,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    };

    //* 节点
    const nodes = {
        input: ref<HTMLInputElement>(),
        form: ref<InstanceType<typeof ModuleForm>>(),
    };

    //* 工具函数
    const utils = {
        resolve: (str: string) => {
            //* 数据初始化
            const result = <{ mm_entrez: number; effect_size: number }[]>[];
            const data = str?.replaceAll("\r\n", "\n")?.split("\n") || [];
            //* 遍历解析数据
            data.forEach((val) => {
                const temporary = val.split(",");
                const MMEntrez = Number((temporary[0] || "").trim());
                const EffectSize = Number((temporary[1] || "").trim());
                if (!isNaN(MMEntrez) && !isNaN(EffectSize) && MMEntrez && EffectSize) {
                    result.push({ mm_entrez: MMEntrez, effect_size: EffectSize });
                }
            });

            return result;
        },
    };

    //* 函数列表
    const methods = {
        //* 上传函数
        upload: (ev: any) => {
            //* 数据初始化
            const reader = new FileReader();
            const file = ev.target?.files?.[0];
            const type = file.name.split(".").slice(-1)[0];

            //* 加载器激活
            $loading.open({ message: i18n.t("UnderLoad"), delay: 200 });

            //* 文件类型解析
            if (["txt", "csv", "xls", "xlsx"].indexOf(type) == -1) $message.error(i18n.t("MTHPlaceholder1"));
            else {
                reader.readAsBinaryString(file);
            }

            //* 文件解析
            refs.data.value = [];
            reader.onload = () => {
                //* 数据初始化
                const result = reader.result?.toString() || "";
                //* 根据文件类型触发对应的解析策略
                if (!["xls", "xlsx"].includes(type)) refs.data.value = utils.resolve(result);
                else {
                    //* 数据初始化
                    const excel = XLSX.read(result, { type: "binary" });
                    const sheet = excel.Sheets[excel.SheetNames[0]] || {};
                    const sheetArray = XLSX.utils.sheet_to_csv(sheet);
                    //* 数据解析
                    refs.data.value = utils.resolve(sheetArray);
                }

                //* 解析数据为空处理
                if (!refs.data.value.length) {
                    $message.error(i18n.t("MTHPlaceholder2"));
                } else {
                    //* 数据更新
                    refs.name.value = file.name;
                    //* 消息提示
                    $message.success(i18n.t("DataResolveSuccess"));
                }

                //* 清空输入框内容，允许重复上传同个文件
                ev.target.value = "";

                //* 加载器关闭
                $loading.close();
            };
        },

        //* 提交函数
        submit: () => {
            if (!refs.data.value.length) $message.error(i18n.t("MTHPlaceholder3"));
            else {
                nodes.form.value?.open(refs.name.value, refs.data.value);
            }
        },
    };

    return { refs, nodes, methods };
};
